import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-414a5228"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page-wrapper"
};
const _hoisted_2 = {
  class: "content-wrapper"
};
const _hoisted_3 = {
  class: "home-main"
};
const _hoisted_4 = {
  class: "current-postion-nav"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 您当前所在位置： ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" > 详情 ");

const _hoisted_7 = {
  key: 0,
  class: "apply-success"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "success-hint"
}, "已报名，请在规定时间内参加学习", -1));

const _hoisted_9 = {
  class: "lecture-address"
};
const _hoisted_10 = {
  key: 1,
  class: "apply-success-box"
};
const _hoisted_11 = {
  class: "apply-success"
};
const _hoisted_12 = {
  class: "success-hint"
};
const _hoisted_13 = {
  class: "lecture-address"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 参与报名抽签 > ");

const _hoisted_15 = {
  class: "lecture-detail-main"
};
const _hoisted_16 = {
  class: "detail-header"
};
const _hoisted_17 = {
  class: "detail-header-main"
};
const _hoisted_18 = {
  class: "header-info"
};
const _hoisted_19 = {
  class: "title"
};
const _hoisted_20 = {
  class: "tag"
};
const _hoisted_21 = {
  key: 1,
  class: "iconfont icon-tongguo"
};
const _hoisted_22 = {
  style: {
    "margin-top": "5px"
  }
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-line"
}, null, -1));

const _hoisted_24 = {
  class: "detail-content-main"
};
const _hoisted_25 = {
  class: "lecture-list"
};
const _hoisted_26 = {
  class: "lecture-item"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lecture-subtitle"
}, "活动时间：", -1));

const _hoisted_28 = {
  class: "lecture-content"
};
const _hoisted_29 = {
  key: 0,
  class: "lecture-item"
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lecture-subtitle"
}, "活动地址：", -1));

const _hoisted_31 = {
  class: "lecture-content"
};

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lecture-subtitle"
}, "主讲人：", -1));

const _hoisted_33 = {
  key: 0,
  class: "teacher-list"
};
const _hoisted_34 = ["src"];
const _hoisted_35 = {
  class: "teacher-name"
};
const _hoisted_36 = {
  class: "teacher-title"
};

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lecture-subtitle"
}, "活动介绍：", -1));

const _hoisted_38 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_SuccessFilled = _resolveComponent("SuccessFilled");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled");

  const _component_el_button = _resolveComponent("el-button");

  const _component_ApplyForm = _resolveComponent("ApplyForm");

  const _component_LiveIcon = _resolveComponent("LiveIcon");

  const _component_Clock = _resolveComponent("Clock");

  const _component_LiveVideo = _resolveComponent("LiveVideo");

  const _component_Footer = _resolveComponent("Footer");

  const _component_ApplyDrawDialog = _resolveComponent("ApplyDrawDialog");

  const _component_DrawResultDialog = _resolveComponent("DrawResultDialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("section", _hoisted_1, [_createVNode(_component_Head, {
    onGetUserInfo: $options.getUserInfo,
    menuCode: "40005"
  }, null, 8, ["onGetUserInfo"]), _createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleBack && $options.handleBack(...args))
  }, _toDisplayString($data.menuName), 1), _hoisted_6]), $data.userInfo.id && $data.lectureInfo.type === 2 && +$data.lectureInfo.live_status < 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$data.lectureInfo.is_draw == 0 && +$data.lectureInfo.applicantsStatus > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_icon, {
    class: "apply-success-icon"
  }, {
    default: _withCtx(() => [_createVNode(_component_SuccessFilled)]),
    _: 1
  }), _createElementVNode("div", null, [_hoisted_8, _createElementVNode("p", _hoisted_9, "活动地址：" + _toDisplayString($data.lectureInfo.address), 1)])])) : _createCommentVNode("", true), $data.lectureInfo.is_draw == 1 && +$data.lectureInfo.draw_type < 5 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_icon, {
    class: "apply-success-icon"
  }, {
    default: _withCtx(() => [$data.lectureInfo.draw_type == 2 ? (_openBlock(), _createBlock(_component_CircleCloseFilled, {
      key: 0
    })) : (_openBlock(), _createBlock(_component_SuccessFilled, {
      key: 1
    }))]),
    _: 1
  }), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, _toDisplayString($options.formateDrawStatus(+$data.lectureInfo.draw_type)), 1), _createElementVNode("p", _hoisted_13, "活动地址：" + _toDisplayString($data.lectureInfo.address), 1)])]), $data.lectureInfo.draw_type == 4 ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    plain: "",
    class: "ballot-btn",
    onClick: _cache[1] || (_cache[1] = $event => $data.showApplyDialog = true)
  }, {
    default: _withCtx(() => [_hoisted_14]),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $options.getApplyFormStatus ? (_openBlock(), _createBlock(_component_ApplyForm, {
    key: 2,
    onApplySuccess: $options.getLectureInfo
  }, null, 8, ["onApplySuccess"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("h3", _hoisted_19, _toDisplayString($data.lectureInfo.live_name), 1), _createElementVNode("span", _hoisted_20, _toDisplayString($data.lectureInfo.classify_name), 1)]), _createElementVNode("div", {
    class: _normalizeClass(["lecture-status", {
      'lecture-living-status': $data.lectureInfo.live_status == -2
    }])
  }, [$data.lectureInfo.live_status == -2 ? (_openBlock(), _createBlock(_component_LiveIcon, {
    key: 0,
    color: "var(--el-color-primary)"
  })) : _createCommentVNode("", true), +$data.lectureInfo.live_status > 1 ? (_openBlock(), _createElementBlock("i", _hoisted_21)) : _createCommentVNode("", true), $data.lectureInfo.live_status == 0 ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 2,
    style: {
      "font-size": "20px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_Clock)]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_22, _toDisplayString($data.statusText), 1)], 2)]), _hoisted_23]), _createElementVNode("div", _hoisted_24, [$data.lectureInfo.type === 1 ? (_openBlock(), _createBlock(_component_LiveVideo, {
    key: 0,
    liveUrl: $data.lectureInfo.live_url,
    playback: $data.lectureInfo.playback_url,
    liveStatus: +$data.lectureInfo.live_status
  }, null, 8, ["liveUrl", "playback", "liveStatus"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("p", _hoisted_28, _toDisplayString($options.formatTrainTime), 1)]), $data.lectureInfo.address ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createElementVNode("p", _hoisted_31, _toDisplayString($data.lectureInfo.address), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_hoisted_32, $data.lectureInfo.teachers ? (_openBlock(), _createElementBlock("ul", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lectureInfo.teachers, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: "teacher-item",
      key: index
    }, [_createElementVNode("img", {
      src: item.file_url || require('@/assets/images/common/teacher_icon.png'),
      alt: "",
      class: "teacher-headimg"
    }, null, 8, _hoisted_34), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_35, _toDisplayString(item.teacher_name || ''), 1), _createElementVNode("div", _hoisted_36, _toDisplayString((item.school_name || '') + (item.college_name || '') + ' ' + (item.job_title || '')), 1)])]);
  }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_hoisted_37, _createElementVNode("div", {
    style: {
      "padding-left": "16px"
    },
    "data-html": "",
    innerHTML: $data.lectureInfo.introduction
  }, null, 8, _hoisted_38)])])])])]), _createVNode(_component_Footer)]), _createVNode(_component_ApplyDrawDialog, {
    show: $data.showApplyDialog,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.showApplyDialog = $event),
    liveId: $data.liveId,
    onBallotResult: $options.ballotResult
  }, null, 8, ["show", "liveId", "onBallotResult"]), _createVNode(_component_DrawResultDialog, {
    show: $data.showResultDialog,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.showResultDialog = $event),
    status: $data.ballotStatus
  }, null, 8, ["show", "status"])], 64);
}